import { AuthContextProps } from "../components/auth-context";
import { getData } from "./core";

export default class CounterProductApi {
  static uri = "n/internet/CounterProducts";
  context: AuthContextProps;
  constructor(context: AuthContextProps) {
    this.context = context;
  }
  get(id: number) {
    return getData({
      uri: CounterProductApi.uri,
      id,
      context: this.context,
    });
  }
}
